import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner } from 'elements'
import { formSubmit } from 'utils/form'
import { getReader, updateReader } from 'redux/modules/model/site'
import { readerDetailsSelector, readerDetailsStatusSelector } from 'redux/selectors'
import { SingleReaderForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'


const COMPONENT_CSS_CLASSNAME = 'reader-edit'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class ReaderEdit extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    getReader: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    reader: PropTypes.object,
    readerDetailsStatus: PropTypes.string.isRequired,
    updateReader: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, getReader, match: { params: { siteId, readerSn, targetClientId } } } = this.props
    getReader({ clientId,targetClientId, siteId, readerSn })
  }

  handleSubmit = (values) => {
    const { clientId, history, reader, updateReader } = this.props
    const siteId = get(reader, 'siteId');
    const targetClientId = get(reader, 'clientId');
    const readerSn = get(reader, 'readerSn');
    const changes = {
      endpoint: values.endpoint
    }
    return formSubmit(updateReader, { clientId,targetClientId, siteId, readerSn, changes })
      .then(() => history.push(ROUTES.READER))
  };

  render() {
    const { reader, readerDetailsStatus } = this.props
    const initialValues = reader ? {
      ...reader
    } : null
    
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.READER}>&laquo; Back</Link></p>
          <PageContentTitle>Edit a reader</PageContentTitle>
          {API_PENDING === readerDetailsStatus && <Spinner />}
          {API_SUCCESS === readerDetailsStatus && <SingleReaderForm initialValues={initialValues} onSubmit={this.handleSubmit} />}
          {API_FAIL === readerDetailsStatus && <h2>Reader id is invalid</h2>}
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  reader: readerDetailsSelector,
  readerDetailsStatus: readerDetailsStatusSelector
})

export const actions = {
  getReader,
  updateReader
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(ReaderEdit)



// WEBPACK FOOTER //
// ./src/pages/reader/reader-edit/index.js